import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSchool = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.99101 12.2V16.124C5.99101 17.073 6.46601 17.958 7.25501 18.483L8.86201 19.552C10.763 20.816 13.237 20.816 15.137 19.552L16.744 18.483C17.534 17.958 18.008 17.072 18.008 16.124V12.2M9.70301 4.09499L3.52901 7.52499C2.23101 8.24599 2.23101 10.112 3.52901 10.833L9.70301 14.263C11.131 15.056 12.868 15.056 14.297 14.263L20.471 10.833C21.769 10.112 21.769 8.24599 20.471 7.52499L14.297 4.09499C12.868 3.30199 11.132 3.30199 9.70301 4.09499Z",
		stroke: "#111827",
		strokeWidth: 1.4167,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSchool);
export default ForwardRef;
